"use client";

import { useEffect } from "react";

export function MarketingLayoutEffects() {
  useEffect(() => {
    return () => {
      document
        .querySelectorAll<HTMLLinkElement>("link[data-marketing-css]")
        .forEach((link) => {
          link.disabled = true;
        });
    };
  }, []);

  return null;
}

export default MarketingLayoutEffects;
